import { Row, Col, Button } from 'antd';
import { HomeCaptchaForm } from '@bit/ui-common.ui-components/ss-components';
import AfspAcknowledgment from '@bit/ui-common.ui-components/afsp/react/components/AfspAcknowledgement';  
import * as captchaService from '@bit/ui-common.ui-components/ss-common-data/redux/services/captchaServices';
import { Container } from '@bit/ui-common.ui-components/ss-components';
export default Container({
    state: state => ({

    }),
    services: [
        captchaService
    ]

}, class extends React.Component {
    state = {
        showAcknowledgement: false,
        captchaInput: ''
    }
    constructor(props) { 
        super(props); 
        this.updateCaptchaField = this.updateCaptchaField.bind(this);

    }
    
    updateCaptchaField(e){
        const
        { services } = this.props,
        value = e.target.value;
        if(this.state.captchaInput.length !== 8 && value.length === 8){
            services.checkCaptcha(value);
        }
        this.setState((state,props) => {
            return {...state, 
                    captchaFormProps: {...state.captchaFormProps, field:value},
                    captchaInput: value
                     }
           });
    }


    
    render() {
        const { captcha, captchaServices, doRequestAccount, doBack } = this.props.data,
        { status } = captcha.validation,
        {captchaInput, showAcknowledgement} = this.state;
        return (
            <div>
                <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '10px' }}>
                    <Col>
                        <HomeCaptchaForm services={captchaServices}
                                        updateCaptchaField={this.updateCaptchaField}
                                        captchaInput={captchaInput}
                                        state={captcha} />
                    </Col>
                </Row>
                <AfspAcknowledgment showAcknowledgement = {showAcknowledgement} role = "p" 
                                description = "Provider registration acknowledgement statement"
                                onDeny= {() => this.setState({ showAcknowledgement : false})} 
                                onAccept= {() =>{
                                    doRequestAccount(captchaInput)
                                }} 
                                denyButton={true}/> 
                <Row type='flex' justify='space-around' align='middle'>
                    <Col>
                        <div style={{ marginBottom: '10px' }}>
                            <Button
                                size='small'
                                icon='check-circle-o'
                                type='primary'
                                style={{ width: '240px', borderRadius: '40px' }}
                                disabled={status === 'failure' || status == null}
                                onClick={() => //hello doRequestAccount()}
                               { this.setState({ showAcknowledgement : true});
                               }}
                            >
                                {'Request Account'}
                            </Button>
                        </div>
                        <div>
                            <Button
                                size='small'
                                icon='rollback'
                                type='default'
                                style={{ width: '240px', borderRadius: '40px' }}
                                onClick={() => doBack()}
                            >
                                {'Back'}
                            </Button>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}
)
